import React from 'react';


function Tabs() {

    return (
    // <!-- tabs -->

        <div className="tab" id="tab">

        {/* <!-- Log in page --> */}
        <p 
            className="tab-text"
            name="log-in-tab"
            onClick={() => { 
                // add line to menu & remove from other tabs
                document.getElementsByName('log-in-tab')[0].classList.add('tab-line')
                document.getElementsByName('new-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('select-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('admin-tab')[0].classList.remove('tab-line')
                document.getElementsByName('cover-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('labor-details-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('materials-details-tab')[0].classList.remove('tab-line')
                // show appropriate view by showing/hiding content 
                document.getElementById('container-log-in').style.visibility='visible';
                document.getElementById('container-log-in').style.display='block';
                document.getElementById('container-new-project-receipt').style.visibility='hidden';
                document.getElementById('container-new-project-receipt').style.display='none';
                document.getElementById('container-select-project-receipt').style.visibility='hidden';
                document.getElementById('container-select-project-receipt').style.display='none';
                document.getElementById('container-admin').style.visibility='hidden';
                document.getElementById('container-admin').style.display='none';
                document.getElementById('container-cover-page').style.visibility='hidden';
                document.getElementById('container-cover-page').style.display='none';
                document.getElementById('container-labor-details-page').style.visibility='hidden';
                document.getElementById('container-labor-details-page').style.display='none';
                document.getElementById('container-materials-details-page').style.visibility='hidden';
                document.getElementById('container-materials-details-page').style.display='none';
            }}
        >
            Log In 
        </p>

        {/* <!-- new project receipt tab --> */}
        <p 
            className="tab-text tab-line"
            name="new-project-receipt-tab"
            onClick={() => {
                // add line to menu & remove from other tabs
                document.getElementsByName('log-in-tab')[0].classList.remove('tab-line')
                document.getElementsByName('new-project-receipt-tab')[0].classList.add('tab-line')
                document.getElementsByName('select-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('admin-tab')[0].classList.remove('tab-line')
                document.getElementsByName('cover-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('labor-details-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('materials-details-tab')[0].classList.remove('tab-line')
                // show appropriate view by showing/hiding content 
                document.getElementById('container-log-in').style.visibility='hidden';
                document.getElementById('container-log-in').style.display='none';
                document.getElementById('container-select-project-receipt').style.visibility='hidden';
                document.getElementById('container-select-project-receipt').style.display='none';
                document.getElementById('container-admin').style.visibility='hidden';
                document.getElementById('container-admin').style.display='none';
                document.getElementById('container-cover-page').style.visibility='hidden';
                document.getElementById('container-cover-page').style.display='none';
                document.getElementById('container-labor-details-page').style.visibility='hidden';
                document.getElementById('container-labor-details-page').style.display='none';
                document.getElementById('container-materials-details-page').style.visibility='hidden';
                document.getElementById('container-materials-details-page').style.display='none';
                document.getElementById('container-new-project-receipt').style.visibility='visible';
                document.getElementById('container-new-project-receipt').style.display='block';
            }}
        >
            New Project Receipt
        </p>
        
        {/* <!-- Select Project Receipt tab --> */}
        <p 
            className="tab-text"
            name="select-project-receipt-tab"
            onClick={() => {
                // add line to menu & remove from other tabs
                document.getElementsByName('log-in-tab')[0].classList.remove('tab-line')
                document.getElementsByName('new-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('select-project-receipt-tab')[0].classList.add('tab-line')
                document.getElementsByName('admin-tab')[0].classList.remove('tab-line')
                document.getElementsByName('cover-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('labor-details-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('materials-details-tab')[0].classList.remove('tab-line')
                // show appropriate view by showing/hiding content 
                document.getElementById('container-log-in').style.visibility='hidden';
                document.getElementById('container-log-in').style.display='none';
                document.getElementById('container-new-project-receipt').style.visibility='hidden';
                document.getElementById('container-new-project-receipt').style.display='none';
                document.getElementById('container-select-project-receipt').style.visibility='visible';
                document.getElementById('container-select-project-receipt').style.display='block';
                document.getElementById('container-admin').style.visibility='hidden';
                document.getElementById('container-admin').style.display='none';
                document.getElementById('container-cover-page').style.visibility='hidden';
                document.getElementById('container-cover-page').style.display='none';
                document.getElementById('container-labor-details-page').style.visibility='hidden';
                document.getElementById('container-labor-details-page').style.display='none';
                document.getElementById('container-materials-details-page').style.visibility='hidden';
                document.getElementById('container-materials-details-page').style.display='none';
            }}
        >
            Select Project Receipt
        </p>

        {/* <!-- IF THE USER IS ADMIN --> */}

        {/* <!-- admin tab --> */}
        <p 
            className="tab-text"
            name="admin-tab"
            onClick={() => {
                // add line to menu & remove from other tabs
                document.getElementsByName('log-in-tab')[0].classList.remove('tab-line')
                document.getElementsByName('new-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('select-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('admin-tab')[0].classList.add('tab-line')
                document.getElementsByName('cover-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('labor-details-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('materials-details-tab')[0].classList.remove('tab-line')
                // show appropriate view by showing/hiding content 
                document.getElementById('container-log-in').style.visibility='hidden';
                document.getElementById('container-log-in').style.display='none';
                document.getElementById('container-admin').style.visibility='visible';
                document.getElementById('container-admin').style.display='block';
                document.getElementById('container-new-project-receipt').style.visibility='hidden';
                document.getElementById('container-new-project-receipt').style.display='none';
                document.getElementById('container-select-project-receipt').style.visibility='hidden';
                document.getElementById('container-select-project-receipt').style.display='none';
                document.getElementById('container-cover-page').style.visibility='hidden';
                document.getElementById('container-cover-page').style.display='none';
                document.getElementById('container-labor-details-page').style.visibility='hidden';
                document.getElementById('container-labor-details-page').style.display='none';
                document.getElementById('container-materials-details-page').style.visibility='hidden';
                document.getElementById('container-materials-details-page').style.display='none';
            }}
        >
            Admin
        </p>

        {/* <!-- ENDIF THE USER IS ADMIN --> */}

        {/* <!-- Cover Page tab --> */}
        <p 
            className="tab-text"
            name="cover-page-tab"
            onClick={() => {
                // add line to menu & remove from other tabs
                document.getElementsByName('log-in-tab')[0].classList.remove('tab-line')
                document.getElementsByName('new-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('select-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('admin-tab')[0].classList.remove('tab-line')
                document.getElementsByName('cover-page-tab')[0].classList.add('tab-line')
                document.getElementsByName('labor-details-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('materials-details-tab')[0].classList.remove('tab-line')
                // show appropriate view by showing/hiding content 
                document.getElementById('container-log-in').style.visibility='hidden';
                document.getElementById('container-log-in').style.display='none';
                document.getElementById('container-new-project-receipt').style.visibility='hidden';
                document.getElementById('container-new-project-receipt').style.display='none';
                document.getElementById('container-select-project-receipt').style.visibility='hidden';
                document.getElementById('container-select-project-receipt').style.display='none';
                document.getElementById('container-admin').style.visibility='hidden';
                document.getElementById('container-admin').style.display='none';
                document.getElementById('container-cover-page').style.visibility='visible';
                document.getElementById('container-cover-page').style.display='block';
                document.getElementById('container-labor-details-page').style.visibility='hidden';
                document.getElementById('container-labor-details-page').style.display='none';
                document.getElementById('container-materials-details-page').style.visibility='hidden';
                document.getElementById('container-materials-details-page').style.display='none';
            }}
        >
            Cover Page
        </p>

        {/* <!-- Labor Details Page tab --> */}
        <p 
            className="tab-text"
            name="labor-details-page-tab"
            onClick={() => {
                // add line to menu & remove from other tabs 
                document.getElementsByName('log-in-tab')[0].classList.remove('tab-line')
                document.getElementsByName('new-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('select-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('admin-tab')[0].classList.remove('tab-line')
                document.getElementsByName('cover-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('labor-details-page-tab')[0].classList.add('tab-line')
                document.getElementsByName('materials-details-tab')[0].classList.remove('tab-line')
                // show appropriate view by showing/hiding content 
                document.getElementById('container-log-in').style.visibility='hidden';
                document.getElementById('container-log-in').style.display='none';
                document.getElementById('container-new-project-receipt').style.visibility='hidden';
                document.getElementById('container-new-project-receipt').style.display='none';
                document.getElementById('container-select-project-receipt').style.visibility='hidden';
                document.getElementById('container-select-project-receipt').style.display='none';
                document.getElementById('container-admin').style.visibility='hidden';
                document.getElementById('container-admin').style.display='none';
                document.getElementById('container-cover-page').style.visibility='hidden';
                document.getElementById('container-cover-page').style.display='none';
                document.getElementById('container-labor-details-page').style.visibility='visible';
                document.getElementById('container-labor-details-page').style.display='block';
                document.getElementById('container-materials-details-page').style.visibility='hidden';
                document.getElementById('container-materials-details-page').style.display='none';
            }}
        >
            Labor Details Page
        </p>

        {/* <!-- Materials Details Page tab --> */}
        <p 
            className="tab-text"
            name="materials-details-tab"
            onClick={() => {
                // add line to menu & remove from other tabs
                document.getElementsByName('log-in-tab')[0].classList.remove('tab-line')
                document.getElementsByName('new-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('select-project-receipt-tab')[0].classList.remove('tab-line')
                document.getElementsByName('admin-tab')[0].classList.remove('tab-line')
                document.getElementsByName('cover-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('labor-details-page-tab')[0].classList.remove('tab-line')
                document.getElementsByName('materials-details-tab')[0].classList.add('tab-line')
                // show appropriate view by showing/hiding content 
                document.getElementById('container-log-in').style.visibility='hidden';
                document.getElementById('container-log-in').style.display='none';
                document.getElementById('container-new-project-receipt').style.visibility='hidden';
                document.getElementById('container-new-project-receipt').style.display='none';
                document.getElementById('container-select-project-receipt').style.visibility='hidden';
                document.getElementById('container-select-project-receipt').style.display='none';
                document.getElementById('container-admin').style.visibility='hidden';
                document.getElementById('container-admin').style.display='none';
                document.getElementById('container-cover-page').style.visibility='hidden';
                document.getElementById('container-cover-page').style.display='none';
                document.getElementById('container-labor-details-page').style.visibility='hidden';
                document.getElementById('container-labor-details-page').style.display='none';
                document.getElementById('container-materials-details-page').style.visibility='visible';
                document.getElementById('container-materials-details-page').style.display='block';
            }}
        >
            Materials Details Page
        </p>

        </div>

        // <!-- end of tabs -->
    )
};

export default Tabs;